import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import { Columns } from 'react-bulma-components'
import './style/JN02.css'
import timer from '../../utils/timer'

function JN02day3() {
    const[showButton, setShowButton] = useState(false)

    useEffect(() => {
        checkDay();
    }, []);
    
    function checkDay(){
        let isDay = timer.checkDate(2, 18)
        setShowButton(isDay)
    }
    return (
        <div>
            <div className="jn02-poem-box">
                <Columns class="columns">
                    <Columns.Column class="column is-4">
                        <div className="jn02-poem-box-square">
                            <div className="jn02-box jn02-box-2"><p>3</p></div>
                        </div>
                    </Columns.Column>
                    <Columns.Column class="column is-8">
                        <div className="jn02-poem-box-content">
                            <p className="day2">
😀+ intercourse become + 🤢+ coitus interruptus + 😵+ sexual activity + 😦 + studies that + 🥳+ typically without + 😩+ the involving + 💀 + the latter + 👺  + insertion of this + 👩 + thrusting of dopamine +  🦵 + latin word + 🫀+ into her will + 😣+ sexual partners have + 😳+ pleasure and reproduction to issues + 🥶+ both temporary +  😖+ this is involuntary + 😰+ intercourse has become +  👩‍🎨+  intercourse outside of + 👸 + anal or digital + 👰‍♀️+ penetration no significance + 🧟‍♀️+ oral or no + 💆‍♀️+ penetration is commonly + 🧍‍♀️+ mouth and a + 😶‍🌫️+ oral sex other + 🗣️ + penetration might be + 💏 + fingering or sexual + 🧖‍♀️+ sexual addiction to + 💃+ penetration is not + 🤣+ fingers or sexual +  😛+ penetration or coitus + 🤐+ especially a divorce + 😒+ strap on differences + 🥵+ these crimes + 😪+ these areas + 🤥+ in activities but in +  😲+ involve physical attractiveness + 😥+ physical intimacy and + 🤱+ intimacy between penetration + 🦹‍♀️+ between states in +  🏃‍♀️+ more closely matched + 💑+ individuals who died + 👥+ usually practiced less + 👚+ used to engage + 🦺+ among singles that + 🫂+ humans the heart + 🤚+ solely for annulment + 🤟+ physical intimacy and + 🤖 + emotional bond and + 👿+ pleasure this form + 🥱+ contribute to stimulate + 🤬+ human right in + 🥸 + bonding in various + 😔 + there were estimated + 🧎‍♀️ + different words such + 👪 + views or recommendations + 👣 + what happens inside + 👗 + constitutes sexual encounters + 🧶 + sexual function orgasm + 🧵 + intercourse which regulate + 🤷‍♀️ + other regulations or + 🙇‍♀️ + sexual behavior adultery + 🤦‍♀️ + activity such marriages + 🙆‍♀️ + which includes restrictions + 👵 + impact charging and + 🦴 + sexual orientation should + 🤳 + health care and + 👍 + although there are + 👎 + sexual dissatisfaction due + 😈 + intercourse many couples + 😤 + particularly if a + 🤯 + variant coitus or + 🤤 + coitus interruptus there + 👔 + generally means the + 👢 + denotes penetrative oral + 🩸 + penetration no actual + 😵‍💫 + creating offspring it + 😮‍💨 + offspring it harm + 👝 + also largely based + 😐 + commonly one freedom + 😟 + there is just so much danger                             </p>
                            <br/>
                        </div>
                    </Columns.Column>
                </Columns>
            </div>
            <div className="jn02-options">
                <Columns class="columns is-mobile">
                    <Columns.Column class="column is-4 jn02-col">
                        <Link to="/poems/JN022" className="jn02-option">Day 2</Link>
                    </Columns.Column>
                    <Columns.Column class="column is-4 jn02-col">
                        <Link to="/menu" className="jn02-option">Home</Link>
                    </Columns.Column>
                    <Columns.Column class="column is-4 jn02-col">
                    {showButton === true ? (
                        <Link to="/poems/JN024" className="jn02-option">Day 4</Link> ) : 
                        (<div><p>Not Yet</p></div>)}
                    </Columns.Column>
                </Columns>
            </div>
        </div>
    );
}

export default JN02day3